import { Controller } from "react-hook-form";
import { Input } from "@/components/ui/input";
import { FieldShell, type FieldComponentProps } from "./field-shell";

export function TextField({ field, control, disabled }: FieldComponentProps) {
  if (field.kind !== "text") return null;
  return (
    <Controller
      name={field.name}
      control={control}
      render={({ field: f, fieldState }) => (
        <FieldShell
          id={f.name}
          label={field.label}
          required={field.required}
          helpText={field.helpText}
          error={fieldState.error?.message}
        >
          <Input
            id={f.name}
            value={f.value == null ? "" : String(f.value)}
            onChange={(e) => f.onChange(e.target.value)}
            onBlur={f.onBlur}
            placeholder={field.placeholder}
            maxLength={field.maxLength}
            disabled={disabled}
            aria-invalid={!!fieldState.error}
          />
        </FieldShell>
      )}
    />
  );
}
